import React, { useEffect, Suspense, lazy, useState } from "react";
import Connect from "../redux/Connect.hoc";
// Components
import App from "../../containers/root/App";

// ! Routes
import PublicRoutes from "./public/public.routes";
import PrivateRoutes from "./private/private.routes";
const AppRouter = ({ state }) => {
  // const checkLogin = async () => {
  //   state.auth.token;

  // };

  const [fondo, setFondo] = useState("/background_home.png");
  useEffect(() => {
    // checkLogin();
  }, []);

  return (
    <App fondo = {fondo}>
      <Suspense fallback={<div>Loading</div>}>
        {state.auth.token ? <PrivateRoutes /> : <PublicRoutes />}
      </Suspense>
    </App>
  );
};

export default Connect(AppRouter);
